import axiosIns from '@/plugins/axios'

export default {
  getSlipTemplates(params) {
    return axiosIns.get('/v2/utility/settings/slip_templates', { params })
  },
  createSlipTemplate(data) {
    return axiosIns.post('/v2/utility/settings/slip_templates', data)
  },
  updateSlipTemplate(id, data) {
    return axiosIns.put(`/v2/utility/settings/slip_templates/${id}`, data)
  },
  evaluateSlipTemplate(data) {
    return axiosIns.post('/v2/utility/slip_template_evaluations', data)
  },
}
